// Caches the transport "tiles" (id / label / icon) from the last successful main-context load
// so the home booking widget paints the vehicle icons INSTANTLY on the next visit, instead of
// waiting on /api/configuratorMainContext. The live booking data (dates, times, prices) still
// loads after — only the visual tiles are served from cache/static defaults up front.
import type { TransportContext } from './api/types'

export type TransportTile = { id: number; label: string; iconUri: string }

// One slot per locale: the labels are backend text, so a single shared slot repainted the
// previous language's vehicle names on the next visit.
const KEY = 'gsm.transportTiles.v1'
const keyFor = (locale: string) => `${KEY}.${locale}`

// Shown on a first-ever visit (empty cache) so the icons never start as blank shimmer.
// Mirrors the live backend (1 = Auto, 2 = Moto); replaced by real data the moment it loads.
export const STATIC_TILES: TransportTile[] = [
  { id: 1, label: 'Auto', iconUri: 'booking-car.png' },
  { id: 2, label: 'Moto', iconUri: 'booking-motorcycle.png' },
]

export function loadTransportTiles(locale: string): TransportTile[] {
  try {
    const raw = localStorage.getItem(keyFor(locale))
    const arr = raw ? (JSON.parse(raw) as TransportTile[]) : null
    return Array.isArray(arr) && arr.length ? arr : STATIC_TILES
  } catch {
    return STATIC_TILES
  }
}

export function saveTransportTiles(ctx: TransportContext[], locale: string): void {
  try {
    const tiles: TransportTile[] = ctx.map((c) => ({
      id: c.transport.id,
      label: c.transport.label,
      iconUri: c.transport.iconUri,
    }))
    localStorage.setItem(keyFor(locale), JSON.stringify(tiles))
  } catch {
    /* ignore private-mode / quota errors — caching is best-effort */
  }
}
